import { useTranslate } from '@tolgee/react';
import { Select, SelectProps } from 'antd';
import { uniqBy } from 'lodash-es';
import { regionFixedExchangeRate } from 'services/config/region';

function CurrencySelector(props: SelectProps<string>) {
  const { t } = useTranslate();

  return (
    <div>
      <span>{t('ViewDashboard.履约数据.金额货币为')}</span>
      <Select
        options={uniqBy(
          Object.values(regionFixedExchangeRate).map(({ region, shorthand }) => ({
            label: shorthand,
            value: region,
          })),
          'value',
        )}
        bordered={false}
        placeholder="CNY"
        dropdownMatchSelectWidth={false}
        {...props}
      />
    </div>
  );
}

export default CurrencySelector;
